import React from 'react';
import { formErrorTextPropTypes } from '@App/common/components/FormErrorText/FormErrorTextPropTypes';
import FormErrorTextCommon from '@App/common/components/FormErrorText/FormErrorText';
import * as styles from './FormErrorText.module.scss';
const FormErrorText = props => /*#__PURE__*/React.createElement(FormErrorTextCommon, Object.assign({}, props, {
  classname: `${styles.root} ${props.classname || ''}`
}));
export default FormErrorText;